import React, {useEffect, useState} from 'react';
import '../../../../../../App.css';
import {Modal} from 'antd';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import {useNavigate} from 'react-router-dom';
import {
    useCreateSinglePaymentRequest, useGetBatchId, useGetUserBankDetails, useNameEnquiry,
} from '../../hooks/usePayment';
import {NumericFormat} from 'react-number-format';
import {MetroSpinner} from 'react-spinners-kit';

const Schema = Yup.object().shape({
    fundingAccount: Yup.string().required('Funding Account is required'),
    businessName: Yup.string().required('Business Name is required'),
    beneficiaryTin: Yup.string().required('Tin is required').matches(/^\d{8}-0001$/, {message: ['Tin should be an eight digit number, then - and then 0001']}),
    phoneNumber: Yup.string().required('Phone Number is required').matches(/^(?:\+?234|0)?[789]\d{9}$/, {message: ['Enter a valid phone number']}),
    emailAddress: Yup.string().required('Email Address is required').matches(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/, {message: ['Enter a valid email address']}),
    grossAmount: Yup.string().required('Gross Amount is required'),
    invoiceNumber: Yup.string(),
    vat: Yup.string().required('vatis required'),
    vatAmount: Yup.string().required('Vat Amount is required'),
    contractDescription: Yup.string().required('Contract Description is required'), // from: Yup.string().required('Date is required'),
    // to: Yup.string().required('Date is required'),
});

const initialValues = {
    fundingAccount: '',
    businessName: '',
    beneficiaryTin: '',
    phoneNumber: '',
    emailAddress: '',
    grossAmount: '',
    invoiceNumber: '',
    vat: '',
    vatAmount: '',
    contractDescription: '',
};

const VatSingleKeyIn = () => {
    const [successModal, setSuccessModal] = useState(false);

    const {data, error, mutate, isLoading} = useCreateSinglePaymentRequest();
    const [accountData, setAccountData] = useState(['']);
    const [insuficientFundModal, setInsuficientFundModal] = useState(false);
    const [confirmationModal, setConfirmationModal] = useState(false);

    const {
        data: nameEnquiry, mutate: mutateNameEnquiry, isLoading: isLoadingNameEnquiry,
    } = useNameEnquiry();

    const {
        data: batchId, mutate: mutateBatchId, isLoading: isLoadingBatchId,
    } = useGetBatchId();

    const {
        data: bankData, mutate: mutateBankData, isLoading: isLoadingBankData,
    } = useGetUserBankDetails();

    const navigate = useNavigate();

    useEffect(() => {
        mutateBankData();
        mutateBatchId();
    }, []);

    const formik = useFormik({
        initialValues, validationSchema: Schema, onSubmit: async (values) => {
            console.log(values);

            setConfirmationModal(false)

            setAccountData(values.fundingAccount.split('-'));

            console.log(accountData);


            mutate({
                data: {
                    batchId: batchId, accountType: {
                        code: accountData[2], value: accountData[3],
                    }, narration: values.contractDescription, expenseType: 'VAT', paymentType: {
                        code: 'vat_payment', description: 'Value Added Tax',
                    }, paymentInstructions: [{
                        sourceAccount: accountData[0],
                        businessName: values.businessName,
                        amount: values.vatAmount,
                        beneficiaryTin: values.beneficiaryTin,
                        phoneNumber: values.phoneNumber,
                        emailAddress: values.emailAddress,
                        grossAmount: values.grossAmount,
                        invoiceNumber: values.invoiceNumber,
                        sourceBankAccountCode: accountData[2],
                        sourceName: accountData[1], // from: values.from,
                        // to: values.to,
                        vat: values.vat,
                        paymentType: {
                            code: 'vat_payment', description: 'Value Added Tax',
                        },
                        destAccountName: `${values.businessName}`,
                    },],
                },
            }, {
                onSuccess: (res: any) => {
                    setSuccessModal(true);
                },
            });
            //  setSuccessModal(true)
        },
    });


    const [vatAmount, setVatAmount] = useState(0);



    const vatPercentage = (event: any) => {
        let result: any = 0;

        formik.setFieldValue('vat', event.floatValue);

        let coAm: any = formik.values.grossAmount;

        result = (event.floatValue / 100) * coAm;

        if (Number.isNaN(result)) {
            result = 0;
        }

        formik.setFieldValue("vatAmount", result)
    };


    const handleSelectAccountChange = (event) => {

        console.log(event);


        // setAccountData(event.target.value.split("-"))
    };


    function checkSufficientBalance() {
        var processingFee = 100
        setAccountData(formik.values.fundingAccount.split('-'))

        var accountData2 = formik.values.fundingAccount.split('-')

        console.log(accountData2);


        const check = Number(formik.values.vatAmount + processingFee) > Number(accountData2[4])
        console.log({check})
        return check
    }

    return (<>

            {isLoading || isLoadingBatchId || isLoadingBankData || isLoadingBatchId ?
                <div className="d-flex justify-content-center align-items-center my-10">
                    <MetroSpinner color="#1f8505"/>
                </div> : <div className={'vatPayment'}>
                    <div className={'vatPaymentBreadcrumb'}>
                        <div>Payments</div>
                        <svg
                            width="10"
                            height="13"
                            viewBox="0 0 10 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M0 1.5744L0 11.4256C0 11.8254 0.236844 12.192 0.613658 12.3774C0.991157 12.5628 1.44706 12.5363 1.79669 12.3087L9.55942 7.25661C9.83645 7.07665 10.0007 6.78017 10 6.46438C9.99858 6.14825 9.83207 5.85271 9.55431 5.6742L1.79158 0.68791C1.44044 0.462617 0.986688 0.438175 0.610557 0.623958C0.235339 0.809997 0 1.1757 0 1.5744Z"
                                fill="#1F8505"
                            />
                        </svg>
                        <div>Tax Payments</div>

                        <svg
                            width="10"
                            height="13"
                            viewBox="0 0 10 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M0 1.5744L0 11.4256C0 11.8254 0.236844 12.192 0.613658 12.3774C0.991157 12.5628 1.44706 12.5363 1.79669 12.3087L9.55942 7.25661C9.83645 7.07665 10.0007 6.78017 10 6.46438C9.99858 6.14825 9.83207 5.85271 9.55431 5.6742L1.79158 0.68791C1.44044 0.462617 0.986688 0.438175 0.610557 0.623958C0.235339 0.809997 0 1.1757 0 1.5744Z"
                                fill="#1F8505"
                            />
                        </svg>
                        <div>Value Added Tax</div>

                        <svg
                            width="10"
                            height="13"
                            viewBox="0 0 10 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M0 1.5744L0 11.4256C0 11.8254 0.236844 12.192 0.613658 12.3774C0.991157 12.5628 1.44706 12.5363 1.79669 12.3087L9.55942 7.25661C9.83645 7.07665 10.0007 6.78017 10 6.46438C9.99858 6.14825 9.83207 5.85271 9.55431 5.6742L1.79158 0.68791C1.44044 0.462617 0.986688 0.438175 0.610557 0.623958C0.235339 0.809997 0 1.1757 0 1.5744Z"
                                fill="#1F8505"
                            />
                        </svg>

                        <div>Key-In</div>
                    </div>

                    <div className={'vatSingleKeyIn'}>
                        <div className={'vatSingleKeyInRow1'}>
                            <div onClick={() => navigate('/admin/payment/tax-payments/vat')}>
                                <svg
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clip-path="url(#clip0_7037_76293)">
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M18 11.8125H9.63312L13.4763 7.96937L12.5 7L7 12.5L12.5 18L13.4694 17.0306L9.63312 13.1875H18V11.8125Z"
                                            fill="#1F8505"
                                        />
                                    </g>
                                    <rect
                                        x="0.75"
                                        y="1.25"
                                        width="22.5"
                                        height="22.5"
                                        rx="11.25"
                                        stroke="#1F8505"
                                        stroke-width="1.5"
                                    />
                                    <defs>
                                        <clipPath id="clip0_7037_76293">
                                            <rect y="0.5" width="24" height="24" rx="12" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>

                            <div>Value Added Tax (VAT)</div>
                        </div>

                        <div className={'vatSingleKeyInForm'}>
                            <div className={'selectFundingDiv'}>
                                <div>Select funding account</div>

                                <div>
                                    <div className={`mt-1`}>
                                        <div className={`form-control form-control-solid`}>
                                            <select
                                                className={`no-outline fs-8 ${formik.values.fundingAccount !== '' ? 'text-dark' : 'text-muted'} `}
                                                {...formik.getFieldProps('fundingAccount')}
                                                //  onChange={(e: any) => handleSelectAccountChange(e)}
                                            >
                                                <option value="">
                                                    Select account to make payment from
                                                </option>

                                                {bankData?.map((array: any, i: any) => {
                                                    return (<option
                                                            value={`${array.accountNumber}-${array.accountName}-${array.accountType.code}-${array.accountType.description.replace('-', '')}-${array.balance}`}
                                                            key={i}
                                                        >
                                                            {array?.accountName}- {array?.accountNumber}-₦{array?.balance.toLocaleString('en-US', {
                                                            minimumFractionDigits: 2, maximumFractionDigits: 2
                                                        })}
                                                        </option>);
                                                })}
                                            </select>
                                        </div>
                                    </div>

                                    <div></div>
                                </div>
                            </div>

                            <div className={'beneficiaryDetails'}>
                                <div>Beneficiary Details</div>
                                <div className={'detailsRow'}>
                                    <div className="mt-1">
                                        <div className="col-form-label py-0 input-height">
                                            <label className="required fw-bold fs-9">
                                                Business Name
                                            </label>
                                        </div>
                                        <div className={`form-control form-control-solid`}>
                                            <input
                                                type="text"
                                                placeholder="Business Name"
                                                className={'no-outline text-dark fs-8'}
                                                {...formik.getFieldProps('businessName')}
                                            />
                                        </div>
                                        <div className="fv-plugins-message-container input-height">
                                            <div className="fv-help-block fs-9 text-danger">
                                                {formik.touched.businessName && formik.errors.businessName && formik.errors.businessName}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-1">
                                        <div className="col-form-label py-0 input-height">
                                            <label className="required fw-bold fs-9">
                                                TIN
                                            </label>
                                        </div>
                                        <div className={`form-control form-control-solid`}>
                                            <input
                                                type="text"
                                                placeholder="TIN"
                                                className={'no-outline text-dark fs-8'}
                                                {...formik.getFieldProps('beneficiaryTin')}
                                            />
                                        </div>
                                        <div className="fv-plugins-message-container input-height">
                                            <div className="fv-help-block fs-9 text-danger">
                                                {formik.touched.beneficiaryTin && formik.errors.beneficiaryTin && formik.errors.beneficiaryTin}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={'detailsRow'}>
                                    <div className="mt-1">
                                        <div className="col-form-label py-0 input-height">
                                            <label className="required fw-bold fs-9">
                                                Phone number
                                            </label>
                                        </div>
                                        <div className={`form-control form-control-solid`}>
                                            <input
                                                type="text"
                                                placeholder="Phone number"
                                                className={'no-outline text-dark fs-8'}
                                                {...formik.getFieldProps('phoneNumber')}
                                            />
                                        </div>
                                        <div className="fv-plugins-message-container input-height">
                                            <div className="fv-help-block fs-9 text-danger">
                                                {formik.touched.phoneNumber && formik.errors.phoneNumber && formik.errors.phoneNumber}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-1">
                                        <div className="col-form-label py-0 input-height">
                                            <label className="required fw-bold fs-9">
                                                Email address
                                            </label>
                                        </div>
                                        <div className={`form-control form-control-solid`}>
                                            <input
                                                type="text"
                                                placeholder="Email address"
                                                className={'no-outline text-dark fs-8'}
                                                {...formik.getFieldProps('emailAddress')}
                                            />
                                        </div>
                                        <div className="fv-plugins-message-container input-height">
                                            <div className="fv-help-block fs-9 text-danger">
                                                {formik.touched.emailAddress && formik.errors.emailAddress && formik.errors.emailAddress}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className={'detailsRow'}>
                                    <div className="mt-1">
                                        <div className="col-form-label py-0 input-height">
                                            <label className="required fw-bold fs-9">
                                                Gross amount
                                            </label>
                                        </div>
                                        <div className={`form-control form-control-solid`}>
                                            <NumericFormat
                                                type="text"
                                                prefix="₦"
                                                thousandsGroupStyle="thousand"
                                                thousandSeparator=","
                                                className="no-outline text-dark fs-8"
                                                placeholder="Gross Amount"
                                                allowNegative={false}
                                                allowLeadingZeros={false}
                                                decimalScale={2}
                                                onValueChange={(event) => {
                                                    formik.setFieldValue('grossAmount', event.floatValue);
                                                    formik.setFieldValue('vat', 0);

                                                    setVatAmount(0);
                                                }}
                                            />
                                        </div>
                                        <div className="fv-plugins-message-container input-height">
                                            <div className="fv-help-block fs-9 text-danger">
                                                {formik.touched.grossAmount && formik.errors.grossAmount && formik.errors.grossAmount}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-1">
                                        <div className="col-form-label py-0 input-height">
                                            <label className="fw-bold fs-9">Invoice number</label>
                                        </div>
                                        <div className={`form-control form-control-solid`}>
                                            <input
                                                type="text"
                                                placeholder="Invoice Number"
                                                className={'no-outline text-dark fs-8'}
                                                {...formik.getFieldProps('invoiceNumber')}
                                            />


                                        </div>
                                        <div className="fv-plugins-message-container input-height">

                                            <div className="fv-help-block fs-9 text-danger">
                                                {formik.touched.invoiceNumber && formik.errors.invoiceNumber && formik.errors.invoiceNumber}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={'detailsRow'}>
                                    <div className="mt-1">
                                        <div className="col-form-label py-0 input-height">
                                            <label className="required fw-bold fs-9">VAT%</label>
                                        </div>
                                        <div className={`form-control form-control-solid`}>

                                            <NumericFormat
                                                type="text"
                                                suffix={'%'}
                                                fixedDecimalScale={true}
                                                className="no-outline text-dark fs-8"
                                                placeholder="VAT%"
                                                allowNegative={false}
                                                allowLeadingZeros={false}
                                                decimalScale={1}
                                                onValueChange={(event) => vatPercentage(event)}
                                            />
                                        </div>
                                        <div className="fv-plugins-message-container input-height">
                                            <div className="fv-help-block fs-9 text-danger">
                                                {formik.touched.vat && formik.errors.vat && formik.errors.vat}
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`mt-1`}>
                                        <div className="col-lg-4 col-form-label py-0 input-height">
                                            <label className="required fw-bold fs-9">
                                                VAT Amount
                                            </label>
                                        </div>
                                        <div className={'form-control form-control-solid'}>

                                            <input
                                                type="text"
                                                placeholder="VAT Amount"
                                                readOnly
                                                className={"no-outline text-dark fs-8"}
                                                {...formik.getFieldProps("vatAmount")}
                                            />
                                        </div>
                                        <div className="fv-plugins-message-container input-height">
                                            <div className="fv-help-block fs-9 text-danger">
                                                {formik.touched.vatAmount && formik.errors.vatAmount && formik.errors.vatAmount}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className="mt-1">
                                        <div className="col-form-label py-0 input-height">
                                            <label className="required fw-bold fs-9">
                                                Contract description
                                            </label>
                                        </div>
                                        <div className={`form-control form-control-solid`}>
                                            <input
                                                type="text"
                                                placeholder="Contract description"
                                                className={'no-outline text-dark fs-8'}
                                                {...formik.getFieldProps('contractDescription')}
                                            />
                                        </div>
                                        <div className="fv-plugins-message-container input-height">
                                            <div className="fv-help-block fs-9 text-danger">
                                                {formik.touched.contractDescription && formik.errors.contractDescription && formik.errors.contractDescription}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/*<div className={'beneficiaryDetails'}>*/}
                            {/*  <div>Pay period</div>*/}

                            {/*  <div className={'detailsRow'}>*/}
                            {/*    <div className="mt-1">*/}
                            {/*      <div className="col-form-label py-0 input-height">*/}
                            {/*        <label className=" fw-bold fs-9">From:</label>*/}
                            {/*      </div>*/}
                            {/*      <div className={`form-control form-control-solid`}>*/}
                            {/*        <input*/}
                            {/*            type="date"*/}
                            {/*            placeholder="From"*/}
                            {/*            className={'no-outline text-dark fs-8'}*/}
                            {/*            {...formik.getFieldProps('from')}*/}
                            {/*        />*/}
                            {/*      </div>*/}
                            {/*      <div className="fv-plugins-message-container input-height">*/}
                            {/*        <div className="fv-help-block fs-9 text-danger">*/}
                            {/*          {formik.touched.from &&*/}
                            {/*              formik.errors.from &&*/}
                            {/*              formik.errors.from}*/}
                            {/*        </div>*/}
                            {/*      </div>*/}
                            {/*    </div>*/}

                            {/*    <div className="mt-1">*/}
                            {/*      <div className="col-form-label py-0 input-height">*/}
                            {/*        <label className=" fw-bold fs-9">To:</label>*/}
                            {/*      </div>*/}
                            {/*      <div className={`form-control form-control-solid`}>*/}
                            {/*        <input*/}
                            {/*            type="date"*/}
                            {/*            placeholder="To"*/}
                            {/*            className={'no-outline text-dark fs-8'}*/}
                            {/*            {...formik.getFieldProps('to')}*/}
                            {/*        />*/}
                            {/*      </div>*/}
                            {/*      <div className="fv-plugins-message-container input-height">*/}
                            {/*        <div className="fv-help-block fs-9 text-danger">*/}
                            {/*          {formik.touched.to &&*/}
                            {/*              formik.errors.to &&*/}
                            {/*              formik.errors.to}*/}
                            {/*        </div>*/}
                            {/*      </div>*/}
                            {/*    </div>*/}
                            {/*  </div>*/}
                            {/*</div>*/}
                        </div>

                        {formik.isValid && formik.dirty ? (<div className={'vatSingleKeyInSubmitButton'}>
                                <button
                                    // onClick={() => formik.handleSubmit()}
                                    onClick={() => checkSufficientBalance() ? setConfirmationModal(true) : setConfirmationModal(true)}
                                    style={{background: '#1F8505'}}
                                >
                                    Submit
                                </button>
                            </div>) : (<div className={'vatSingleKeyInSubmitButton'}>
                                <button
                                    disabled
                                    onClick={() => setSuccessModal(false)}
                                    style={{background: '#CCCCCC'}}
                                >
                                    Submit
                                </button>
                            </div>)}
                    </div>

                    <Modal
                        centered
                        style={{width: '500px', maxWidth: '100%'}}
                        open={successModal}
                        onOk={() => {
                            navigate('/admin/payment/tax-payments');
                            setSuccessModal(false);
                        }}
                        onCancel={() => {
                            navigate('/admin/payment/tax-payments');
                            setSuccessModal(false);
                        }}
                        footer={null}
                    >
                        <div className={'ppSuccessModal'}>
                            <svg
                                style={{justifySelf: 'center'}}
                                width="50"
                                height="50"
                                viewBox="0 0 50 50"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M33.5937 20.3125L22.1354 31.25L16.4062 25.7812M43.75 25C43.75 35.3553 35.3553 43.75 25 43.75C14.6447 43.75 6.25 35.3553 6.25 25C6.25 14.6447 14.6447 6.25 25 6.25C35.3553 6.25 43.75 14.6447 43.75 25Z"
                                    stroke="#FBCB38"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>

                            <div className={'ppSuccessModalTitle'}>Successful!</div>

                            <div className={'ppSuccessModalDesc'}>
                                Your transaction with GPR no {batchId} has been sent to the reviewer
                                group for action.
                            </div>

                            <div className={'ppSuccessModalActionButton'}>
                                <button
                                    onClick={() => {
                                        navigate('/admin/payment/tax-payments');
                                        setSuccessModal(false);
                                    }}
                                >
                                    Done
                                </button>
                            </div>
                        </div>
                    </Modal>


                    <Modal
                        centered
                        style={{width: "500px", maxWidth: "100%"}}
                        open={insuficientFundModal}
                        onOk={() => setInsuficientFundModal(false)}
                        onCancel={() => setInsuficientFundModal(false)}
                        footer={null}
                    >
                        <div className={"rvpConfirmationModal"}>
                            <svg
                                style={{justifySelf: "center"}}
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M17.1562 9.1875L10.2812 15.75L6.84375 12.4688M23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12Z"
                                    stroke="#61CD85"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>

                            <div className={"rvpConfirmationModalTitle"}>Insufficient Fund!</div>

                            <div style={{textAlign: "center"}}>
                                You do not have surficent balance in this account (
                                <span style={{color: "#1F8505"}}>{accountData[1]} - {accountData[0]}</span>) Kindly fund
                                the account or
                                select
                                another account with sufficient fund
                            </div>

                            <div className={"rvpConfirmationModalActionButton"}>
                                <button
                                    className="btn btn-success px-7 py-2 h-44 w-150 rounded-1 "
                                    onClick={() => {
                                        setInsuficientFundModal(false);
                                        // mutateBatchId();
                                    }}
                                >
                                    <span className="indicator-label fs-base text-White">Ok</span>
                                </button>
                            </div>
                        </div>
                    </Modal>

                    <Modal
                        centered
                        style={{width: "500px", maxWidth: "100%"}}
                        open={confirmationModal}
                        onOk={() => setConfirmationModal(false)}
                        onCancel={() => setConfirmationModal(false)}
                        footer={null}
                    >
                        <div className={"rvpConfirmationModal"}>
                            <svg
                                style={{justifySelf: "center"}}
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M11.2499 13.8755C11.2499 14.2897 11.5857 14.6255 11.9999 14.6255C12.4142 14.6255 12.7499 14.2897 12.7499 13.8755H11.2499ZM11.9999 12.938V12.188C11.801 12.188 11.6103 12.267 11.4696 12.4077C11.329 12.5483 11.2499 12.7391 11.2499 12.938H11.9999ZM7.96869 9.65678C7.96869 10.071 8.30448 10.4068 8.71869 10.4068C9.1329 10.4068 9.46869 10.071 9.46869 9.65678H7.96869ZM22.5 12C22.5 17.799 17.799 22.5 12 22.5V24C18.6274 24 24 18.6274 24 12H22.5ZM12 22.5C6.20101 22.5 1.5 17.799 1.5 12H0C0 18.6274 5.37258 24 12 24V22.5ZM1.5 12C1.5 6.20101 6.20101 1.5 12 1.5V0C5.37258 0 0 5.37258 0 12H1.5ZM12 1.5C17.799 1.5 22.5 6.20101 22.5 12H24C24 5.37258 18.6274 0 12 0V1.5ZM12.6562 18.0938C12.6562 18.4562 12.3624 18.75 12 18.75V20.25C13.1909 20.25 14.1562 19.2846 14.1562 18.0938H12.6562ZM12 18.75C11.6376 18.75 11.3438 18.4562 11.3438 18.0938H9.84375C9.84375 19.2846 10.8091 20.25 12 20.25V18.75ZM11.3438 18.0938C11.3438 17.7313 11.6376 17.4375 12 17.4375V15.9375C10.8091 15.9375 9.84375 16.9029 9.84375 18.0938H11.3438ZM12 17.4375C12.3624 17.4375 12.6562 17.7313 12.6562 18.0938H14.1562C14.1562 16.9029 13.1909 15.9375 12 15.9375V17.4375ZM12.7499 13.8755V12.938H11.2499V13.8755H12.7499ZM11.9999 13.688C12.7972 13.688 13.5766 13.4516 14.2396 13.0086L13.4062 11.7614C12.99 12.0396 12.5006 12.188 11.9999 12.188L11.9999 13.688ZM14.2396 13.0086C14.9025 12.5657 15.4192 11.9361 15.7243 11.1995L14.3385 10.6254C14.1469 11.088 13.8225 11.4833 13.4062 11.7614L14.2396 13.0086ZM15.7243 11.1995C16.0294 10.4629 16.1093 9.6523 15.9537 8.87032L14.4826 9.16295C14.5802 9.65397 14.5301 10.1629 14.3385 10.6254L15.7243 11.1995ZM15.9537 8.87032C15.7982 8.08833 15.4142 7.37003 14.8505 6.80625L13.7898 7.86691C14.1438 8.22091 14.3849 8.67194 14.4826 9.16295L15.9537 8.87032ZM14.8505 6.80625C14.2867 6.24247 13.5684 5.85853 12.7864 5.70299L12.4938 7.17416C12.9848 7.27183 13.4358 7.51291 13.7898 7.86691L14.8505 6.80625ZM12.7864 5.70299C12.0044 5.54744 11.1939 5.62727 10.4572 5.93239L11.0313 7.31821C11.4938 7.12662 12.0027 7.0765 12.4938 7.17416L12.7864 5.70299ZM10.4572 5.93239C9.72063 6.2375 9.09104 6.7542 8.64808 7.41713L9.89528 8.25049C10.1734 7.83423 10.5687 7.50979 11.0313 7.31821L10.4572 5.93239ZM8.64808 7.41713C8.20512 8.08007 7.96869 8.85947 7.96869 9.65678H9.46869C9.46869 9.15614 9.61715 8.66675 9.89528 8.25049L8.64808 7.41713Z"
                                    fill="#61CD85"
                                />
                            </svg>

                            {/*<div className={'rdFilterModalRow1'}>*/}
                            <div className={"rvpConfirmationModalTitle"}>Confirmation</div>
                            {/*</div>*/}

                            <div style={{justifySelf: "center"}}>
                                Please confirm you want to proceed with this request
                            </div>

                            <div className={"rvpConfirmationModalActionButton"}>
                                <button
                                    className="btn btn-outline-success px-7 py-2 h-44 w-200 rounded-1 "
                                    onClick={() => setConfirmationModal(false)}
                                >
                                    <span className="indicator-label fs-base">Cancel</span>
                                </button>

                                <button
                                    onClick={() => formik.handleSubmit()}
                                    className="btn btn-success px-7 py-2 h-44 w-150 rounded-1 "
                                >
              <span className="indicator-label fs-base text-White">
                Proceed
              </span>
                                </button>
                            </div>
                        </div>
                    </Modal>
                </div>}

        </>);
};

export default VatSingleKeyIn;
